import { DialogDisclosure, useStoreState } from "@ariakit/react";
import { AccountIcon } from "@indietabletop/appkit";
import { Link } from "wouter";
import { fragment } from "../common.css";
import { SpineCenter, SpineContainer, SpineItem } from "../oss/Layout/Layout";
import { Sidenav } from "../oss/Layout/Sidenav";
import { useSidenavStore } from "../oss/Layout/SidenavContext";
import { MenuIcon } from "../PageHeaderButton/Icon";
import logoSrc from "./logo.png";
import { spine } from "./style.css";

export function Spine() {
  const store = useSidenavStore();
  const isOpen = useStoreState(store, (s) => s.open);

  return (
    <>
      <SpineContainer>
        <SpineItem render={<DialogDisclosure store={store} />}>
          <MenuIcon isOpen={isOpen} />
        </SpineItem>

        <SpineCenter>
          <Link href="~/" className={fragment}>
            <img src={logoSrc} alt="Greathelm" className={spine.image} />
          </Link>
        </SpineCenter>

        <SpineItem>
          <Link to="/settings" className={spine.action}>
            <AccountIcon imgSrc="/icon.png" />
          </Link>
        </SpineItem>
      </SpineContainer>

      <Sidenav />
    </>
  );
}
